import { Directive, Input } from '@angular/core';
import { NG_ASYNC_VALIDATORS, AsyncValidator, UntypedFormControl } from '@angular/forms';
import { ApplicationContextService } from '../../../common/services/application-context.service';
import { IAppConfigDesignerConfig } from '../../../common/designer-config-service/appconfig/app-config-designer';

@Directive({
  selector: '[appUniqueSettingName]',
  providers: [
    { provide: NG_ASYNC_VALIDATORS, useExisting: UniqueSettingNameValidatorDirective, multi: true }
  ],
  standalone: false
})
export class UniqueSettingNameValidatorDirective implements AsyncValidator {
  @Input('appUniqueSettingName') skipSettingName: string;
  @Input('appConfig') appConfig: IAppConfigDesignerConfig;

  constructor(
    private applicationContextService: ApplicationContextService) { }

  validate(c: UntypedFormControl) {
    return new Promise(resolve => {
      const settingName = c.value;
      if (this.applicationContextService.application.referenceName === settingName
        || (!this.applicationContextService.application.referenceName && settingName === 'app')) {
        resolve({ forbiddenSettingName: true });
        return;
      }

      if (this.appConfig.references.some(r => r.referenceName === settingName)) {
        resolve({ forbiddenSettingName: true });
        return;
      }
      this.appConfig.settings
        .map(i => i.name)
        .filter(i => i !== this.skipSettingName)
        .includes(settingName)
        ? resolve({ uniqueName: true })
        : resolve(null);
    });
  }
}